import {Component, OnInit} from '@angular/core';
import {RequestParams} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {Floor} from './floor.model';
import {FloorService} from './floor.service';
import {Building} from '../building/building.model';
import {CombiFormComponent} from '../shared/combi-form.component';
import {RoutePrefix} from '../shared/route-prefix';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-floor-form',
  templateUrl: './floor-form.component.html'
})
export class FloorFormComponent extends CombiFormComponent implements OnInit {
  public floor: Floor = new Floor();
  public formTitle: string;
  protected stateIdParam: string = 'floorId';
  protected routePrefix: RoutePrefix | RoutePrefix[];
  public activeTab: string = (localStorage.getItem('floorTab')) ? localStorage.getItem('floorTab') : 'drawing';
  public showDrawingAddButton: boolean;
  public floorNumbers: number[] = [];

  constructor(
    protected router: UIRouter,
    protected floorService: FloorService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit() {
    super.ngOnInit();

    switch(this.formMode) {

      case this.FormMode.ADD: {
        this.translate.get('floor.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.fetchAvailableFloorNumbers();
      } break;

      case this.FormMode.UPDATE: {
        this.translate.get('floor.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.routePrefix = [
          {
          entity: Building.name.toLowerCase(),
          entityId: this.router.stateService.params.buildingId
          },
          {
            entity: Floor.name.toLowerCase(),
            entityId: this.router.stateService.params.floorId
          }
        ];

        this.floorService.setRoutePrefix(`${Building.name.toLowerCase()}/${this.router.stateService.params.buildingId}`);
        this.floorService.get(this.router.stateService.params.floorId).subscribe((floor) => {
          this.floor = floor;
          this.fetchAvailableFloorNumbers(true);
        });
      } break;
    }
  }

  private fetchAvailableFloorNumbers(updateForm: boolean = false): void {
    const requestParams = new RequestParams();
    requestParams.pagination.limit = 0;

    this.floorService.setRoutePrefix(`${Building.name.toLowerCase()}/${this.router.stateService.params.buildingId}`);
    this.floorService.getAll(requestParams).subscribe((floors: Floor[]) => {
      const usedFloors = floors.map((floor: Floor) => {
        return floor.number;
      });

      this.floorNumbers = [];
      const minFloor = -10;
      const maxFloor = 30;

      for(let i = minFloor; i <= maxFloor; i++) {
        if(usedFloors.indexOf(i) === -1 || (updateForm === true && this.floor.number === i)) {
          this.floorNumbers.push(i);
        }
      }
    });
  }

  public save() {
    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.floorService.add(this.floor).subscribe((response) => {
          const floor = new Floor();
          floor.fromResponse(response);
          this.router.stateService.go('building.edit.floor.edit', Object.assign({}, this.router.stateService.params.buildingId, {floorId: floor.id}), {reload: true});
        });
      } break;

      case this.FormMode.UPDATE : {
        this.floorService.update(this.floor).subscribe((response) => {
          this.router.stateService.go('building.edit', {buildingId: this.router.stateService.params.buildingId}, {reload: true});
        });
      } break;
    }
  }

  public onTabSelect(tab) {
    localStorage.setItem('floorTab', tab);
  }

  public onDrawingsLoaded(drawing) {
    this.showDrawingAddButton = (drawing.items.length === 0);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor-form.component.ts